import ButtonA from "@src/ruix/components/atoms/buttons/ButtonA";
import GroupA from "@src/ruix/components/atoms/groups/GroupA";
import ImageA from "@src/ruix/components/atoms/images/ImageA";
import PaperA from "@src/ruix/components/atoms/papers/PaperA";
import TitleA from "@src/ruix/components/molecules/Titles/TitleA";
import { MatchConsultantInfoProps } from "@src/ruix/types";

const MatchConsultantInfo = (props: MatchConsultantInfoProps) => {
	const { name, imgSrc, onClickEmail, onClickWhattime } = props;

	return (
		<PaperA variant="white" order="row-end-between" gap={20}>
			<GroupA gap={10} order="row-center-between">
				<ImageA width={74} height={74} imgSrc={imgSrc} />
				<TitleA
					title="매칭 컨설턴트"
					subTitle={name}
					color="primary"
					subTitleColor="var(--card-bg)"
				></TitleA>
			</GroupA>
			<GroupA order="row-start-start" gap={10}>
				<ButtonA buttonClass="primary" onClick={onClickEmail}>
					이메일 문의하기
				</ButtonA>
				<ButtonA buttonClass="primary" onClick={onClickWhattime}>
					비대면 미팅 예약하기
				</ButtonA>
			</GroupA>
		</PaperA>
	);
};

export default MatchConsultantInfo;
